import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./AuthContext";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

// جعل التطبيق بالكامل بالعربية ومن اليمين إلى اليسار
document.documentElement.lang = "ar";
document.documentElement.dir = "rtl";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);

reportWebVitals();
